const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5600",
  "data-name": "Path 5600",
  d: "M76.043,1600.133l-1.391-2.1-2.435-4.84-3.25-5.163-2.515,3.894-1.2,2.932-1.992,3.1-2.625,4.888,4.233.188,4.218.321,4.218-.57,4-.091Zm-6.154-8.059-.211,6.293h-1.44l-.217-6.293Zm.163,8.979a1.2,1.2,0,0,1-.243.371,1.132,1.132,0,0,1-.377.261,1.162,1.162,0,0,1-.465.095,1.157,1.157,0,0,1-.844-.357,1.19,1.19,0,0,1-.242-.371,1.135,1.135,0,0,1-.092-.45,1.155,1.155,0,0,1,.092-.457,1.248,1.248,0,0,1,.24-.376,1.17,1.17,0,0,1,.37-.266,1.153,1.153,0,0,1,.946,0,1.15,1.15,0,0,1,.375.267,1.278,1.278,0,0,1,.242.378,1.173,1.173,0,0,1,.09.455A1.144,1.144,0,0,1,70.052,1601.053Z",
  transform: "translate(-60.633 -1588.027)",
  fill: "#750000"
});
function SvgSidebarAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 15.321,
    viewBox: "0 0 16.667 15.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAlert);
export default __webpack_public_path__ + "static/media/Sidebar--alert.ec48890d.svg";
export { ForwardRef as ReactComponent };